import axios from 'axios';

const sales_history_api = axios.create({
	baseURL: process.env.VUE_APP_API_URL,
	withCredentials: true,
});

function getErrorStatus(error) {
	return error && error.response ? error.response.status : null;
}

function redirectToExpiredSession() {
	window.location = '/login?sessionExpired=true&backUri=' + window.location.pathname;
}

export async function requestWithInlineErrorHandling(request, session_check, on_session_expired) {
	try {
		return await request();
	} catch (error) {
		const status = getErrorStatus(error);
		if (status === 401) {
			on_session_expired();
		} else if (status === 403) {
			try {
				await session_check();
			} catch (session_error) {
				const session_status = getErrorStatus(session_error);
				if (session_status === 401 || session_status === 403) on_session_expired();
			}
		}
		return Promise.reject(error);
	}
}

export function requestSalesHistorySummary(param) {
	return requestWithInlineErrorHandling(
		() => sales_history_api.post('/api/report/salesHistorySummary', param),
		() => sales_history_api.get('/api/global_session_check'),
		redirectToExpiredSession,
	);
}
